import { makeContactRequestFire } from '../middleware/contact-request'

import { getUserConversations } from '../../Conversations/middleware/conversation-fire'

export const makeContactRequest = (contactInfo) => (dispatch, getState) => {

  var {user: {userProfile, uid}} = getState()
  var username = userProfile.username || userProfile.email
  return Promise.resolve(
    dispatch({
      type: "makeContactRequest",
      contactInfo
    }))

    .then(action => {

      return makeContactRequestFire({
        userId: userProfile.userId,
        username,
        contactInfo
      }, dispatch)

    })

}


// WEBPACK FOOTER //
// ./src/Components/AddContactPage/actions/index.js